<div class="dialog-container">
    <div class="dialog-header">
        <div class="header-icon warning">
            <mat-icon>warning_amber</mat-icon>
        </div>
        <button class="btn-close" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body">
        <h2 class="dialog-title">{{ data.title || 'Remove Truck' }}</h2>
        <p class="dialog-message">
            {{ data.message || 'Are you sure to remove this truck' }} <strong>{{ data.plateNumber }}</strong>?
        </p>
    </div>

    <div class="dialog-actions">
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button class="btn-danger" (click)="onConfirm()">
            <mat-icon>delete_outline</mat-icon>
            <span>{{ data.confirmLabel || 'Remove' }}</span>
        </button>
    </div>
</div>
